import { navigate } from '@reach/router'
import { message, Modal, Spin } from 'antd'
import React from 'react'
import useSWR from 'swr'
import { ROOT_PATH } from '../common/config'
import { queryPayment } from '../services/payment'

interface PaymentResult {
  // 支付流水号 	支付流水号对应ipay88的refNo,交易唯一主键
  paymentNo: string
  // 响应message 	成功或失败信息
  message: string
  // 交易响应时间 	交易响应时间
  paymentEndTime: string
  // 支付订单状态 	TO_PAY待支付,IN_PAY支付中,SUCCESS_PAY成功,FAIL_PAY失败
  paymentStatus: string
  // 交易发起时间 	交易发起时间
  paymentStartTime: string
  // 200表示成功，400订单不存在，其他失败
  code: number
  statusDetail: string
}

export const PaymentInterval: React.FC<{ ano: string; refNo: string }> = ({ ano, refNo }) => {
  // 正式地址
  const { data } = useSWR<PaymentResult>('//e-shenma.com.my/payment/query/' + refNo, async () => await queryPayment(refNo), { refreshInterval: 1000 })
  // 测试地址
  //const { data } = useSWR<PaymentResult>('//sit01.e-shenma.com.my/payment/enquiry/' + refNo, async () => await queryPayment(refNo), { refreshInterval: 1000 })
  if (data) {
    if (Number(data.code) === 200) {
      if (data.paymentStatus === 'SUCCESS_PAY') {
        // message.success('Payment Successfully')
        setTimeout(() => {
          navigate(`${ROOT_PATH}/dashboard/payment/result/success?refNo=${refNo}&ano=${ano}`)
        }, 500)
        return null
      }
      if (data.paymentStatus === 'FAIL_PAY') {
        message.error('Payment failed: ' + data.statusDetail)
        setTimeout(() => {
          navigate(`${ROOT_PATH}/dashboard/payment/result/error?refNo=${refNo}&ano=${ano}`)
        }, 500)
        return null
      }
    } else {
      message.error('Payment failed: ' + data.statusDetail)
      setTimeout(() => {
        navigate(`${ROOT_PATH}/dashboard/payment/result/error?refNo=${refNo}&ano=${ano}`)
      }, 500)
      return null
    }
  }

  return (
    <Modal visible title="Payment in progress" footer={null} onCancel={() => navigate(`${ROOT_PATH}/dashboard/account/${ano}`)}>
      <Spin />
      <p>Your payment is being paid. If you have problems with your payment, you can pay again after 5 minutes, or call customer service. Tel: xxxxxxxxxxx</p>
      <p>Waiting for the processing result</p>
    </Modal>
  )
}
